import { useState } from "react";
import Input from "../../../../Core/Fields/Floating/Input";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
import ActivityCard from "../../../../Core/Activity/ActivityCard";
const Tab3 = ({
  IdData,
  TaxCategory,
  TaxID,
  TaxWithholdingCategory,
  GSTIN_UIN,
  PAN,
  GSTCategory,
}) => {
  return (
     <div>
      <div className="px-2 py-3" style={{ background: 'white' }}>
        <div style={{ display: 'flex' }} >
          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Purchasing Details</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                 <div style={{ flex: 1 }}>
                  <Input
              id="TaxID"
              label="Tax ID"
              style={{ height: "30px" }}
              value={TaxID.TaxID}
              onChange={(e) => TaxID.setTaxID(e.target.value)}
              readOnly
            />

                </div>
                <div style={{ flex: 1 }}>
                   <Input
                    style={{
                      height: "30px",
                    }}
                    label="Tax Category"
                    value={TaxCategory.select_TaxCategory}
                    readOnly
                  />
                   
                </div>
                <div style={{ flex: 1 }}>
                   <Input
                    style={{
                      height: "30px",
                    }}
                    label="Tax With holding Category"
                    value={TaxWithholdingCategory.select_TaxWithholdingCategory}
                    readOnly
                  />
                   
                </div>
              </div>


            </div>
          </div>

          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Tax Details</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>

                <div style={{ flex: 1 }}>
                  <Input
              id="GSTIN_UIN"
              label="GSTIN / UIN"
              style={{ height: "30px" }}
              value={GSTIN_UIN.GSTIN_UIN}
              onChange={(e) => GSTIN_UIN.setGSTIN_UIN(e.target.value)}
              readOnly
            />
                </div>
                <div style={{ flex: 1 }}>
                 <Input
              id="PAN"
              label="PAN"
              style={{ height: "30px" }}
              value={PAN.PAN}
              onChange={(e) => PAN.setPAN(e.target.value)}
              readOnly
            />



                </div>
                <div style={{ flex: 1 }}>
                  <Input
                    style={{
                      height: "30px",
                    }}
                    label="GST Category"
                    value={GSTCategory.GSTCategory}
                    readOnly
                  />
                
                </div>

              </div>




            </div>
          </div>
        </div>
          <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

          <div className="col-md-12">
            <div className='' style={{ height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
             <ActivityCard doctype="Supplier" docname={IdData} />
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Tab3;
